import { render, staticRenderFns } from "./TarefaRetiradaModal.vue?vue&type=template&id=344cdd0e"
import script from "./TarefaRetiradaModal.vue?vue&type=script&lang=js"
export * from "./TarefaRetiradaModal.vue?vue&type=script&lang=js"
import style0 from "./TarefaRetiradaModal.vue?vue&type=style&index=0&id=344cdd0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports